import cx from "classnames";
import type { HTMLAttributes } from "react";

const CLASS_ROOT = "pagination__separator";

const Separator = (props: HTMLAttributes<HTMLLIElement>) => {
  const { className, ...other } = props;
  const itemClasses = cx(CLASS_ROOT, className);

  return (
    <li className={itemClasses} {...other}>
      …
    </li>
  );
};

Separator.displayName = "PaginationSeparator";

export default Separator;
